import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InfoItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-width: 120px;
`

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const IconWrapper = styled.div`
  margin-left: ${Spacing.S4};
`
